


































import { Component,Vue } from 'vue-property-decorator'
import { State,  Getter, Action, namespace } from 'vuex-class'
import { regionData,CodeToText,TextToCode } from 'element-china-area-data'
import { ArrayPropsDefinition } from 'node_modules/vue/types/options';
import MapLocation from '../../components/map.vue'
import ImportBranch from '../../components/common/importBranch.vue'
import AreaSelect from '../../components/common/area'
const site = namespace('site')

interface User {
    name: string, //用户名
    phone: string, // 用户手机号
    area: Array<any>, // 省市区
    com_area: string, //公司区域
    address: string, //公司地址
    sms_address: string, //短信地址
    site_org: any, //组织架构位置
    location: Array<any>, //经纬度
    type: number, //网点类型
    stype: number, //模式
    tc: string, //下班时间
    to: string, //上班时间
    sms_price: number, //短信发送费用
    weixin_price: number, //微信发送费用
    acount: number, //账户
    hasshelf: boolean, //包含货架
    wash: string, //是否开通了洗衣
    images: Array<any>, // 网点图片
    remarks: string //备注
}

@Component({
    components:{
        MapLocation,
        ImportBranch,
        AreaSelect,
    }
})
export default class AddUser extends Vue{
    options = regionData
    selectedOptions = []
    showMap:boolean = false
    editStatus:boolean = false
    id:string = '' //编辑进来传的id
    form:User = {
        name: '',
        phone: '',
        area: [],
        com_area: '',
        address: '',
        sms_address: '',
        site_org: null,
        location: [],
        type: 0,
        stype: 0,
        tc: '',
        to: '',
        sms_price: 0.05,
        weixin_price: 0.03,
        acount: 0,
        hasshelf: true,
        wash: '0',
        images: [],
        remarks: ''
    }
    // 导入网点的时候用的数据
    importBranchData = {
        _id: '',
        qrticket: '',
        qrsceneid: ''
    }
    importBranchVisible:boolean = false //导入网点弹窗
    importList = [] //导入数据的列表
    get formOptions(){
        return [{
            label: '网点名',
            prop: 'name',
            type: 'input',
            ruleType: 'text'
        },{
            label: '电话',
            prop: 'phone',
            type: 'input',
            ruleType: 'text'
        },{
            label: '省市区',
            prop: 'area',
            type: 'slot',
            ruleType: 'array'
        },{
            label: '公司区域',
            prop: 'com_area',
            type: 'select',
            options: this.comArea,
            optionsLabel: 'name',
            optionsValue: 'code',
            ruleType: 'text'
        },{
            label: '门店地址',
            prop: 'address',
            type: 'input',
            ruleType: 'text'
        },{
            label: '短信地址',
            prop: 'sms_address',
            type: 'input',
            ruleType: 'text'
        },{
            label: '组织位置',
            prop: 'site_org',
            type: 'tree',
            options: this.siteOrg,
            treeId: '_id',
            treeLabel: 'name',
            ruleType: 'text'
        },{
            label: '经纬度',
            prop: 'location',
            type: 'slot',
            ruleType: 'array'
        },{
            label: '类型',
            prop: 'type',
            type: 'radio',
            options: this.siteType,
            optionsLabel: 'name',
            optionsValue: 'code',
            ruleType: 'text'
        },{
            label: '模式',
            prop: 'stype',
            type: 'radio',
            options: this.shelfType,
            optionsLabel: 'name',
            optionsValue: 'code',
            ruleType: 'text'
        },{
            label: '下班时间',
            prop: 'tc',
            type: 'time',
            ruleType: 'text'
        },{
            label: '上班时间',
            prop: 'to',
            type: 'time',
            ruleType: 'text'
        },{
            label: '短信发送费用',
            prop: 'sms_price',
            type: 'InputNumber',
            ruleType: 'text',
            min: 0,
            max: 10,
            step: 0.01
        },{
            label: '微信发送费用',
            prop: 'weixin_price',
            type: 'InputNumber',
            ruleType: 'text',
            min: 0,
            max: 10,
            step: 0.01
        },{
            label: '账户金额',
            prop: 'acount',
            type: 'InputNumber',
            ruleType: 'text',
            min: 0,
            step: 1
        },{
            label: '包含货架',
            prop: 'hasshelf',
            type: 'radio',
            options: [{label: '是',value: true},{label: '否',value: false}],
            optionsLabel: 'label',
            optionsValue: 'value',
            ruleType: 'text'
        },{
            label: '开通洗衣',
            prop: 'wash',
            type: 'radio',
            options: [{label: '是',value: '1'},{label: '否',value: '0'}],
            optionsLabel: 'label',
            optionsValue: 'value',
            ruleType: 'text'
        },{
            label: '店铺图片',
            prop: 'images',
            type: 'upload',
            limit: 3,
            ruleType: 'array'
        },{
            label: '备注',
            prop: 'remarks',
            type: 'textarea',
            row: 2
        }]
    }
    // 导数据
    get importBranchColumn(){
        return [
            {
                name: 'operation',
                type: 'slot',
                label: '操作',
                width: '80px',
            },
            {
                prop: 'name',
                type: 'input',
                label: '网点名称',
                width: '160px',
            },
            {
                prop: 'phone',
                type: 'input',
                label: '电话',
                width: '160px',
            },
            {
                prop: 'address',
                type: 'input',
                label: '网点地址',
                width: '160px',
            },
            {
                prop: 'sms_address',
                type: 'input',
                label: '短信地址',
                width: '160px',
            },
            {
                prop: 'price',
                nextProp: 'sms',
                type: 'InputNumber',
                label: '短信费用',
                width: '160px',
            },
            {
                prop: 'price',
                nextProp: 'weixin',
                type: 'InputNumber',
                label: '微信费用',
                width: '160px',
            },
            {
                prop: 'type',
                type: 'select',
                label: '类型',
                options: this.siteType,
                optionsLabel: 'name',
                optionsValue: 'code',
                width: '160px',
            },
            {
                prop: 'status',
                type: 'radio',
                label: '状态',
                width: '160px',
                options: [{
                    name: '启用',
                    code: '0'
                },{
                    name: '禁用',
                    code: '1'
                }],
                optionsLabel: 'name',
                optionsValue: 'code'
            },
            {
                prop: 'to',
                type: 'time',
                label: '上班时间',
                width: '160px',
            },
            {
                prop: 'tc',
                type: 'time',
                label: '下班时间',
                width: '160px',
            }
        ]
    }
    // formOptions =
    @Getter('comArea') comArea:any
    @Getter('siteOrg') siteOrg:any
    @Getter('shelfType') shelfType:any
    @Getter('siteType') siteType:any

    @site.Action('addSite') addSite:any
    @site.Action('getSiteDetail') getSiteDetail:any
    @site.Action('editSite') editSite:any
    @site.Action('importData') importData:any
    async created(){
        const id = this.$route.query.id
        if(id){
            this.editStatus = true
            this.id = id
            const res = await this.getSiteDetail(id);
            if(res){
                this.form = {
                    name: res.name,
                    phone: res.phone,
                    area: res.area,
                    com_area: res.com_area,
                    address: res.address,
                    sms_address: res.sms_address,
                    site_org: res.site_org,
                    location: res.location,
                    type: res.type,
                    stype: res.stype,
                    tc: res.tc,
                    to: res.to,
                    sms_price: res.price.sms,
                    weixin_price: res.price.weixin,
                    acount: res.acount,
                    hasshelf: res.hasshelf,
                    wash: res.wash,
                    images: res.images,
                    remarks: res.remarks
                }
            }
        }

    }
     normalizer(node:any) {
        return {
            id: node._id,
            label: node.name,
            children: node.children,
        }
    }
    showMapFun(){
        this.showMap = true
    }
    changeLocation(e:any){
        this.form.location = []
        this.form.location.push(e.lng)
        this.form.location.push(e.lat)
    }
    async add(){
        console.log(this.form.area);
        const status = await this.$refs.builder.submitForm();
        if(status){
            const res = await this.addSite(this.form)
            if(res){
                this.$message({message: '添加成功', type: 'success'});
                this.resetForm()
            }
        }
    }
    async edit(){
        const status = await this.$refs.builder.submitForm();
        if(status){
            const res = await this.editSite({
                id: this.id,
                data: this.form
            })
            if(res){
                this.$message({message: '修改成功', type: 'success'});
                this.resetForm()
                this.$router.go(-1)
            }
        }
    }
    // 重置表单
    resetForm(){
        this.$refs.builder.resetForm()
    }
    // 打开导入网点弹窗
    async openImportBranch(){
        const res = await this.importData()
        console.log(res);
        this.importList = res
        this.importBranchVisible = true
    }
    // 选择需要导入的哪条字段
    async chooseImport(e:any){
        console.log(e);
        this.importBranchVisible = false
        this.importBranchData._id = e._id
        this.importBranchData.qrsceneid = e.qrsceneid
        this.importBranchData.qrticket = e.qrticket
        this.form.name = e.name
        this.form.phone = e.phone
        this.form.area = ["510000", "510100", "510107"]
        this.form.com_area = e.com_area
        this.form.address = e.address
        this.form.sms_address = e.sms_address
        // this.form.site_org = e.site_org
        // this.form.location = e.location
        this.form.type = 2
        this.form.stype = 0
        this.form.tc = e.tc
        this.form.to = e.to
        this.form.sms_price = e.price.sms
        this.form.weixin_price = e.price.weixin
        this.form.acount = 0
        this.form.hasshelf = false
        this.form.images = ["https://statics.youbanghelper.com/file/88c7f09c-3961-4951-8966-3c26060bcf16.png"]
        // this.form.remarks = e.remarks
    }
    // 提交导入网点
    async sendImportBranch(){
        console.log({...this.form,...this.importBranchData});
        const status = await this.$refs.builder.submitForm();
        if(status){
            this.form.area = [CodeToText[this.form.area[0]],CodeToText[this.form.area[1]],CodeToText[this.form.area[2]]]
            const res = await this.addSite({...this.form,...this.importBranchData})
            if(res){
                this.$message({message: '导入成功', type: 'success'});
                this.resetForm()
            }
        }
    }
}
